import { useMemo } from 'react';

import { BookingSlot } from '../../api/search';
import { Kid } from '../../components/KidsInput';
import {
  DateSlotsPerWeek,
  PickTimesPerWeek,
  getPickTimesFromDateSlots,
} from '../../components/WeekCalendarContainer';
import { DateSlots } from '../../contexts/checkout';
import { transformSlots } from '../../utils/slots';

const useFilteredDateSlots = (
  slotsPerWeek: Record<string, BookingSlot[]>,
  kids: Kid[],
  isLoggedIn: boolean
): {
  dateSlotsPerWeek: DateSlotsPerWeek;
  pickTimesPerWeek: PickTimesPerWeek;
} => {
  const dateSlotsPerWeek = useMemo(
    () =>
      Object.entries(slotsPerWeek).reduce(
        (acc, [weekId, slots]) => ({
          ...acc,
          [weekId]: transformSlots(slots, kids, isLoggedIn),
        }),
        {} as Record<string, DateSlots>
      ),
    [slotsPerWeek, kids, isLoggedIn]
  );

  const pickTimesPerWeek = useMemo(
    () => getPickTimesFromDateSlots(dateSlotsPerWeek),
    [dateSlotsPerWeek]
  );

  const filteredDateSlotsPerWeek = useMemo(
    () =>
      Object.fromEntries(
        Object.entries(dateSlotsPerWeek).filter(
          ([weekid]) => weekid in pickTimesPerWeek
        )
      ),
    [dateSlotsPerWeek, pickTimesPerWeek]
  );

  return {
    dateSlotsPerWeek: filteredDateSlotsPerWeek,
    pickTimesPerWeek,
  };
};
export default useFilteredDateSlots;
